import React from 'react';
import { OpenPosition } from '../../../types/analytics.types';

interface Props {
  positions: OpenPosition[];
}

const OpenPositions: React.FC<Props> = ({ positions }) => {
  if (positions.length === 0) return null;

  return (
    <div className="analytics-section">
      <h3 className="analytics-section-title">Open Positions</h3>
      <div className="analytics-table-wrapper">
        <table className="analytics-table">
          <thead>
            <tr>
              <th className="text-left">Model</th>
              <th className="text-left">Instrument</th>
              <th className="text-center">Direction</th>
              <th className="text-right hide-mobile">Entry Price</th>
              <th className="text-center hide-mobile">Size</th>
              <th className="text-right">Duration</th>
            </tr>
          </thead>
          <tbody>
            {positions.map((pos) => (
              <tr key={pos.trade_id}>
                <td className="text-left model-name">{pos.model}</td>
                <td className="text-left">{pos.instrument}</td>
                <td className={`text-center font-bold ${pos.direction === 'BUY' || pos.direction === 'LONG' ? 'positive' : 'negative'}`}>
                  {pos.direction}
                </td>
                <td className="text-right hide-mobile">${pos.entry_price.toFixed(4)}</td>
                <td className="text-center hide-mobile">{pos.size}</td>
                <td className="text-right">{pos.duration}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OpenPositions;
